"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = __importDefault(require("react"));

const styled_components_1 = __importDefault(require("styled-components"));

const Portal_1 = __importDefault(require("../portal/Portal"));

const Column_1 = __importDefault(require("../column/Column"));

const SnackbarContainer = _a => {
  var {
    portal
  } = _a,
      props = __rest(_a, ["portal"]);

  return react_1.default.createElement(Portal_1.default, {
    portal: portal
  }, react_1.default.createElement(SnackbarColumn, Object.assign({}, props)));
};

exports.default = SnackbarContainer;
const SnackbarColumn = styled_components_1.default(Column_1.default).attrs({
  mainAxisAlignment: 'flex-end',
  crossAxisAlignment: 'flex-end'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 32px;\n  pointer-events: none;\n\n  > * {\n    pointer-events: initial;\n  }\n"])));